/*
  Môdern Match — self-updating catalog (Sep 28, 2026)

  Môdern Match used to search a prebuilt snapshot (studio-match-index.json) that
  went stale whenever products changed. It now builds the same index from the
  live catalog each visit:

    /collections/all?view=match-index&page=1..N   (250 products per page)

  Each product is reduced with MSGMatch.reduceProduct, the exact function the old
  snapshot was generated with, so search results behave the same way.

  How it plugs in: the section's data-index-url points at the feed URL below.
  When Môdern Match requests that URL, this script answers with the assembled
  index. If the live feed can't be loaded, it falls back to the old snapshot
  (data-index-fallback-url) so the tool keeps working.
  Nothing is fetched until a shopper actually runs a search.
*/
(function () {
  'use strict';

  var FEED = '/collections/all?view=match-index';
  var realFetch = window.fetch && window.fetch.bind(window);
  if (!realFetch) return;

  var root = document.querySelector('[data-modern-match]');
  var fallbackUrl = root && root.getAttribute('data-index-fallback-url');
  var building = null;

  function getPage(n) {
    return realFetch(FEED + '&page=' + n, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('feed page ' + n + ': ' + r.status);
      return r.json();
    });
  }

  function build() {
    if (building) return building;
    building = getPage(1).then(function (first) {
      var pages = Math.max(1, first.pages || 1);
      var rest = [];
      for (var n = 2; n <= pages; n++) rest.push(getPage(n));
      return Promise.all(rest).then(function (others) {
        var M = window.MSGMatch;
        if (!M || !M.reduceProduct || !M.productToRow) throw new Error('Môdern Match not loaded');
        var seen = {};
        var rows = [];
        [first].concat(others).forEach(function (page) {
          (page.items || []).forEach(function (p) {
            if (!p || !p.handle || seen[p.handle]) return;
            seen[p.handle] = true;
            rows.push(M.productToRow(M.reduceProduct(p)));
          });
        });
        if (!rows.length) throw new Error('empty feed');
        return { generated: new Date().toISOString(), source: 'live', rows: rows };
      });
    });
    return building;
  }

  function jsonResponse(data) {
    return new Response(JSON.stringify(data), { status: 200, headers: { 'Content-Type': 'application/json' } });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url === FEED || url === location.origin + FEED) {
      return build().then(jsonResponse).catch(function (err) {
        if (window.console) console.warn('[Môdern Match] live catalog unavailable, using saved index', err);
        building = null;
        if (fallbackUrl) return realFetch(fallbackUrl);
        throw err;
      });
    }
    return realFetch(input, init);
  };
})();
